import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { NgApexchartsModule } from 'ng-apexcharts';
import { CustomCurrencyPipeModule } from 'src/app/angular-wallet-base/pipes/customcurrency/customcurrency.module';
import { SafeHtmlsModule } from 'src/app/angular-wallet-base/pipes/safe-htmls/safe-htmls.module';
import { HeaderModule } from 'src/app/components/header/header.module';
import { TabsModule } from 'src/app/components/home-page/tabs/tabs.module';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { HistoryComponent } from './history/history.component';
import { MoveComponent } from './move/move.component';
import { OrderTypeComponent } from './order-type/order-type.component';
import { CancelOrderComponent } from './orders/cancel-order/cancel-order.component';
import { OrdersComponent } from './orders/orders.component';
import { ReviewOrderComponent } from './review-order/review-order.component';
import { TradeHomeComponent } from './trade-home.component';
import { SubTradeComponent } from './trade/trade.component';
import { ExpiryComponent } from './expiry/expiry.component';
import { ExpiryCustomComponent } from './expiry-custom/expiry-custom.component';
import { SuccessOrderComponent } from './success-order/success-order.component';
import { DebounceDirectiveModule } from 'src/app/angular-wallet-base/directives/debounce/debounce-directive.module';
import { SuccessMoveComponent } from './move/success-move-modal/success-move-modal';
import { SelectNetworkModal } from './move/select-network-modal/select-network-modal';
import { SelectAssetModule } from '../select-asset-modal/select-asset-modal.module';
import { MaxDecimalsModule } from 'src/app/angular-wallet-base/directives/max-decimal-digits/max-decimals.module';

const routes: Routes = [
  {
    path: '',
    component: TradeHomeComponent,
  },
];
@NgModule({
  declarations: [
    TradeHomeComponent,
    SubTradeComponent,
    MoveComponent,
    OrdersComponent,
    HistoryComponent,
    CancelOrderComponent,
    OrderTypeComponent,
    ReviewOrderComponent,
    ExpiryComponent,
    ExpiryCustomComponent,
    SuccessOrderComponent,
    SuccessMoveComponent,
    SelectNetworkModal
  ],
  imports: [
    RouterModule.forChild(routes),
    CommonModule,
    IonicModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    NgApexchartsModule,
    TabsModule,
    HeaderModule,
    CustomCurrencyPipeModule,
    SafeHtmlsModule,
    DebounceDirectiveModule,
    SelectAssetModule,
    MaxDecimalsModule,

  ]
})
export class TradeModule { }
